import { PersonalFinanceComponent } from '@kmx/finance-shared-react-components/personal-finance-component';
import { PersonalFinanceComponentV2 } from '@kmx/personal-finance-component';
import { KmxContainer } from '../../../components/KmxContainer';
import useAppState from '../../../common/state/appState';

const PersonalFinanceContainer = () => {
    const serveUFTContentEnabled = useAppState((state) => state.serveUFTContent);
    const isPrequalified = useAppState((state) => state.isPrequalified);
    const usePfcV2 = window.featureFlags.enablePFCv2 === true;
    const environment = window.location.origin === 'https://www.carmax.com' ? 'Prod' : 'Non-Prod';
    const adobeData = { position: 'Homepage', originPage: 'HP_Finance1stModule' };
    const PersonalFinanceVariant = usePfcV2 ? PersonalFinanceComponentV2 : PersonalFinanceComponent;

    if (serveUFTContentEnabled && isPrequalified) return null;

    return (
        <KmxContainer
            maxWidth="xl"
            sx={{
                pt: { xs: 5, lg: 6 },
            }}
        >
            <PersonalFinanceVariant environment={environment} adobeData={adobeData} />
        </KmxContainer>
    );
};

export default PersonalFinanceContainer;
